var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.6 2.4v3h3v1.2h-3v3h-1.2v-3h-3V5.4h3v-3zm4.2 6v1.8h1.8v1.2h-1.8v1.8h-1.2v-1.8h-1.8v-1.2h1.8V8.4zm-9.476.758 1.571 3.187 3.518.51 1.496.217-1.084 1.054-2.546 2.483.6 3.502.259 1.489-1.339-.705-3.146-1.654-3.146 1.654-1.335.705.255-1.489.6-3.502-2.543-2.483L2.4 13.073l1.497-.218 3.517-.51 1.571-3.187.672-1.358zm1.399 4.376-.623-.094-.277-.566-1.166-2.363-1.167 2.363-.277.566-.623.09-2.61.379 1.887 1.837.45.439-.105.623-.447 2.595 2.333-1.227.559-.292.558.292 2.333 1.227-.446-2.595-.105-.623.45-.439 1.886-1.837-2.606-.379z"
  })));
};
export default SvgStars;